import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { registry } from 'lcc-state';
import { createNlsMiddleware, lccstate, userstore, rolldownGotit } from '@holmescorp/lcc-state';
import { BackView } from '@holmescorp/backview';
import { subscribe } from '@holmescorp/pub-sub';
import { XAPI } from '@holmescorp/xapi';
import css from '../css/rise.m.css';
const backviewSelected = {
    selected: () => {
        return;
    }
};
const captureBackviewSelected = (selected) => {
    backviewSelected.selected = selected;
};
const change_state = (subtopic, params) => {
    const { get, path } = userstore;
    const status = get(path('status'));
    const get_topic = (v) => {
        return v.split('//')[1];
    };
    const statement = new XAPI.Statement(params);
    console.log(`xapi subscribe topic ${subtopic}`);
    if (subtopic === 'xapi:passed' && statement.target?.objectType === 'Activity') {
        const topic = get_topic(statement.target.id);
        if (topic) {
            const data = { ...status[topic].data };
            const value = data.complete === 1 ? 0 : 1;
            data.complete = value;
            rolldownGotit(topic, data);
        }
        backviewSelected.selected();
    }
};
subscribe('xapi', change_state);
const nls = createNlsMiddleware('activities');
const factory = create({ theme, nls, lccstate }).properties();
export const RiseActivation = factory(({ properties, middleware: { theme, nls, lccstate } }) => {
    const { isPlaceholder, messages } = nls();
    if (isPlaceholder) {
        return null;
    }
    const { activityname, rel, title: title_prop, key: key_prop } = properties();
    const themeCss = theme.classes(css);
    const { cia_min_height = 390, cia_min_width = 390, invalid_size_warning = '[activities] invalid_size_warning' } = nls().messages;
    const winWidth = window.innerWidth;
    const winHeight = window.innerHeight;
    let isValidSize = true;
    if (winWidth < cia_min_width || winHeight < cia_min_height) {
        isValidSize = false;
    }
    const invalidSize = v('span', { classes: [themeCss.warning] }, [invalid_size_warning]);
    const title = activityname ? messages[`${activityname}_title`] : title_prop;
    const { get, path } = lccstate;
    const association = get(path('title'));
    const product = get(path('product'));
    document.title = `${title} - ${association} - ${product}`;
    const endpoint = encodeURIComponent(`${window.hcstatic.portal_url}/@@lrs/xapi/`);
    const { portal_userid: uid, sessionid } = window.hcstatic;
    const actor = encodeURIComponent(`{"objectType":"Agent","name":"${uid}","mbox":"mailto:${uid}@example.com|${sessionid}"}`);
    const auth = encodeURIComponent(`Bearer ${window.hcstatic.xapi_token}`);
    const risepath = activityname
        ? messages[`${activityname}_path`]
        : `${window.hcstatic.portal_cdn}/rise-content/${rel}/index.html`;
    const queryparams = `?endpoint=${endpoint}&actor=${actor}&auth=${auth}`;
    const url = `${risepath}${queryparams}`;
    console.log(`rise url = ${url}`);
    return v('div', { key: 'riseactivity', xqa: `rise-activity ${activityname || key_prop}`, classes: [themeCss.root] }, [
        v('div', { key: 'activity-title', classes: [themeCss.title] }, [
            w(BackView, { captureSelected: captureBackviewSelected })
        ]),
        v('div', { key: 'rise-body', xqa: `rise-body ${activityname || key_prop}`, classes: [themeCss.body] }, [
            !isValidSize
                ? invalidSize
                : v('iframe', {
                    sandbox: 'allow-same-origin allow-forms allow-scripts',
                    seamless: 'seamless',
                    title: title,
                    src: url
                })
        ])
    ]);
});
registry.define('RiseTopicPage', RiseActivation);
